import ReactDOM from 'react-dom/client';
import App from './App';
import './shared/utils/i18next';
import './assets/css/main.css';
import './assets/css/content.css';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Provider } from 'react-redux';
import store from './shared/store/index';
import { I18nextProvider } from 'react-i18next';
import i18n from './shared/utils/i18next';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </Provider>
);

serviceWorkerRegistration.unregister();
reportWebVitals();
